import { ProfileConsumerGroupsResponse } from "@api/useProfileConsumerGroups";

export enum ConsumerGroup {
    Demographics,
    Restaurants,
    CStores,
    Supermarkets,
    Brands,
    Segments,
    DeliveryService,
    Hotels
}

export const CONSUMER_GROUPS: Array<{
    id: ConsumerGroup;
    title: string;
}> = [
    { id: ConsumerGroup.Demographics, title: "Demographics" },
    { id: ConsumerGroup.Restaurants, title: "Restaurants" },
    { id: ConsumerGroup.CStores, title: "C-Stores" },
    { id: ConsumerGroup.Supermarkets, title: "Supermarkets" },
    { id: ConsumerGroup.Hotels, title: "Hotels" },
    { id: ConsumerGroup.Brands, title: "CPG Brands" },
    { id: ConsumerGroup.Segments, title: "Segment Users" },
    { id: ConsumerGroup.DeliveryService, title: "Delivery" },
];

export const CONSUMER_GROUPS_FIELDS: Record<ConsumerGroup, Array<keyof ProfileConsumerGroupsResponse>> = {
    [ConsumerGroup.Demographics]: ['demographics'],
    [ConsumerGroup.Restaurants]: ['restaurants'],
    [ConsumerGroup.CStores]: ['cStores'],
    [ConsumerGroup.Supermarkets]: ['supermarkets'],
    [ConsumerGroup.Hotels]: ['hotels'],
    [ConsumerGroup.Brands]: ['cpgBrands'],
    [ConsumerGroup.Segments]: ['segments', 'onSites'],
    [ConsumerGroup.DeliveryService]: ['deliveryService'],
}